import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { token, user } = useAuth();

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (user?.Kullanici_Yetki != 0) {
    return <Navigate to="/forms" />;
  }

  return children;
};

export default AdminRoute;
